// this code implemented by ARIA: tab role. Used from Mozilla web Accessibility
const changeTabs = function(e) {
  const target = e.target.parentNode;
  const parent = target.parentNode;
  const grandparent = parent.parentNode;

  // Remove all current selected tabs
  if (parent) {
    parent
      ?.querySelectorAll('[aria-selected="true"]')
      ?.forEach(t => t.setAttribute("aria-selected", false));
  }

  // Set this tab as selected
  if (target) {
    target.setAttribute("aria-selected", true);
  }

  if (grandparent) {
    // Hide all tab panels
    grandparent
      ?.querySelectorAll('[role="tabpanel"]')
      ?.forEach(p => p.setAttribute("hidden", true));

    // Show the selected panel
    grandparent?.parentNode
      ?.querySelector(`#${target.getAttribute("aria-controls")}`)
      ?.removeAttribute("hidden");
  }
};

export const initChangeTabs = () => {
  const tabs = document.querySelectorAll('[role="tab"]');
  const tabList = document.querySelector('[role="tablist"]');

  // Add a click event handler to each tab
  if (tabs) {
    tabs.forEach(tab => {
      tab.addEventListener("click", changeTabs);
    });
  }

  // Enable arrow navigation between tabs in the tab list
  let tabFocus = 0;

  if (tabList) {
    tabList.addEventListener("keydown", e => {
      // Move right
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute("tabindex", -1);
        if (e.keyCode === 39) {
          tabFocus++;
          // If we're at the end, go to the start
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
          // Move left
        } else if (e.keyCode === 37) {
          tabFocus--;
          // If we're at the start, move to the end
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }

        tabs[tabFocus].setAttribute("tabindex", 0);
        tabs[tabFocus].focus();
      }
    });
  }
};
